import React from "react";
import { ACTION_TYPES } from "../constants/enums";

export default function ActionSelector({
  actions = [],
  onChange
}) {

  const toggleAction = (action) => {

    if (actions.includes(action)) {
      onChange(actions.filter(a => a !== action));
    } else {
      onChange([...actions, action]);
    }

  };

  return (

    <div className="form-section">

      <h3 className="section-title">
        Actions
      </h3>

      <div className="checkbox-grid">

        {ACTION_TYPES.map(action => (

          <label
            key={action}
            className="checkbox-item"
          >

            <input
              type="checkbox"
              checked={actions.includes(action)}
              onChange={() => toggleAction(action)}
            />

            <span>{action}</span>

          </label>

        ))}

      </div>

    </div>

  );

}